/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATION, UPDATE_PRESENTATION } from "../graphql";
import { VApplication } from "../../../application";

const log: any = LoggerModule?.getInstance();

export interface UpdatePresentationProps {
  formData: {
    name?: string;
    year?: string;
    status?: string;
    type?: string;
  };
  id: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationMethods extends IPluginMethodMap {
  getPresentationProps(args: any): Promise<any>;
  updatePresentation(args: any): Promise<any>;
}

export class PresentationService implements IAgentPlugin {
  readonly methods: IPresentationMethods;

  constructor() {
    this.methods = {
      getPresentationProps: this.getPresentationProps.bind(this),
      updatePresentation: this.updatePresentation.bind(this),
    };
  }

  async getPresentationProps(args: any) {
    let k = { name: "L" };
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATION,
          variables: {
            filter: {
              ...args,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          return {
            ...res?.data?.getPresentation,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  async updatePresentation(args: UpdatePresentationProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_PRESENTATION,
          variables: {
            filter: {
              _id: args?.id,
            },
            update: {
              ...args?.formData,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updatePresentation,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
